import { ArrowDown, CtaButton, Spinner } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledButtonsContainer = styled.section`
  display: flex;
  justify-content: space-between;
`;

export const StyledContinueButton = styled(CtaButton).attrs({
  tag: 'button',
  user: 'tenant',
})`
  text-transform: uppercase;
  margin: 0;

  span {
    position: relative;
  }

  &:hover {
    color: ${({ theme, variant }) =>
      variant === 'secondary' && theme.colors.tenant.mainAlternate};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    max-width: ${rem('264px')};
    width: 100%;
  }
`;

export const StyledBackButton = styled(CtaButton).attrs({
  tag: 'button',
  user: 'tenant',
})`
  text-transform: uppercase;
  background-color: ${({ theme }) => theme.colors.main};
  border: none;
  box-shadow: none;
  color: ${({ theme }) => theme.colors.tenant.main};
  display: flex;
  align-items: center;
  gap: ${rem('16px')};
  padding-left: 0;
  padding-right: 0;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.main};
  }
`;

export const StyledArrowLeft = styled(ArrowDown)`
  transform: rotate(90deg);
`;

export const StyledSpinner = styled(Spinner)`
  position: absolute;
  left: -${rem('32px')};
  top: 0%;
`;
